import { isPositiveNumber } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { apiCallGetAdminPermissions } from "../../../api/supervisor-api/api-call-get-admin-permissions";
import { apiCallUpdateAdminPermissions } from "../../../api/supervisor-api/api-call-update-admin-permissions";
import i18n from "../../../constants/i18n";
import { TAdminPermissions } from "../../../Types";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class PermissionStore {
  adminInput = observable.box<TEt3PickerSingleValue>({
    value: "",
    label: i18n.get("CHOOSE")
  });

  adminPermissions = observable.box<TAdminPermissions[]>([]);

  adminPermissionsOrdered = computed(() => {
    const orderedAdminPermissions: TAdminPermissions[] = orderBy(
      this.adminPermissions.get(),
      ["moduleId"],
      ["asc"]
    );
    return orderedAdminPermissions;
  });

  setAdmin = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.adminInput.set(admin);
    });
  };

  getPermissions = async () => {
    const currentAdminId = parseInt(this.adminInput.get().value, 10);
    const isdefinedAdminId = isPositiveNumber(currentAdminId);
    if (!isdefinedAdminId) {
      return;
    }

    getCoreUIStore().setIsLoading("SUPERVISOR_PERMISSION", true);
    const { data, status, code } = await apiCallGetAdminPermissions({
      adminId: currentAdminId
    });
    getCoreUIStore().setIsLoading("SUPERVISOR_PERMISSION", false);

    if (status === "OK") {
      this.adminPermissions.set(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  updatePermissionClientSide = ({
    moduleId,
    newPermissionState
  }: {
    moduleId: number;
    newPermissionState: 0 | 1;
  }) => {
    const permissions = this.adminPermissions.get();
    const index = permissions.findIndex((p) => p.moduleId === moduleId);
    if (isPositiveNumber(index, true)) {
      permissions[index].hasPermission = newPermissionState;
    }
  };

  changePermission = async ({
    hasPermissionCurrentState,
    moduleId
  }: {
    hasPermissionCurrentState: number;
    moduleId: number;
  }) => {
    const newPermissionState = isPositiveNumber(hasPermissionCurrentState)
      ? 0
      : 1;

    const adminId = parseInt(this.adminInput.get().value, 10);
    if (!isPositiveNumber(adminId)) {
      return;
    }
    getCoreUIStore().setIsLoading("SUPERVISOR_PERMISSION", true);
    const { status, code } = await apiCallUpdateAdminPermissions({
      adminId,
      newPermissionState,
      moduleId
    });
    getCoreUIStore().setIsLoading("SUPERVISOR_PERMISSION", false);

    if (status === "OK") {
      this.updatePermissionClientSide({
        moduleId,
        newPermissionState
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getPermissionStore = memoize(
  () => new PermissionStore(),
  () => 1
);
export default getPermissionStore;
